import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from '../../atoms/table/Table';
import PaymentTableHeader from '../../molecules/table/PaymentTableHeader';
import PaymentTableRow from '../../molecules/table/PaymentTableRow';
import NoDataTableRow from '../../molecules/table/NoDataTableRow';
import TableRow from '../../atoms/table/TableRow';
import { readableNumberParts } from '../../../helpers/Numbers';
import TableCell from '../../atoms/table/TableCell';
import styled from 'styled-components';
const _Table = styled(Table) `
    position: relative;
`;
const PaymentTable = ({ paymentGroup }) => {
    return (_jsxs(_Table, { hasBorder: true, children: [_jsx(PaymentTableHeader, {}), paymentGroup.items.length > 0 &&
                paymentGroup.items.map((payment, index) => (_jsx(PaymentTableRow, { payment: payment }, index))), paymentGroup.items.length > 0 && (_jsxs(TableRow, { noHover: true, children: [_jsx(TableCell, { value: _jsx("strong", { children: "Totaal:" }) }), _jsx(TableCell, { value: _jsx("strong", { children: readableNumberParts(paymentGroup.total, 'EUR').long }) }), _jsx(TableCell, { "aria-hidden": true })] })), paymentGroup.items.length === 0 && _jsx(NoDataTableRow, {})] }));
};
export default PaymentTable;
